import React, { useState } from "react";
import tw from "twin.macro";

const VideoPlayer = () => {
  const videos = [
    "/videos/SmartViewMD-Picture-Camera.mp4",
    "/videos/SVMD_Chicago_NHCHC_Aug_2025-slide-1-Dorizabelle.mp4",
    "/videos/SVMD_Chicago_NHCHC_Aug_2025-slide-2.mp4",
    "/videos/SVMD_Chicago_NHCHC_Aug_2025-slide-3.mp4",
    "/videos/SVMD_Chicago_NHCHC_Aug_2025-slide-4.mp4",
    "/videos/SVMD_Chicago_NHCHC_Aug_2025-slide-5.mp4"
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const Heading = tw.h1`font-black text-3xl md:text-5xl leading-snug max-w-3xl`;
  const LinkButton = tw.button`
  font-bold underline text-blue-700 hover:text-blue-500
`;


  return (
    <div className="flex flex-col items-center">
      <Heading><h1>Introducing SmartViewMD</h1></Heading>
      <p className="text-sm text-gray-500" date="January 1, 2014">
        {"January 1, 2014"} by{" "}
        <a href="/" className="text-blue-600 hover:underline">Belle IT</a>
      </p>
      <video
        src={videos[currentIndex]}
        controls
        autoPlay
        className="rounded-lg shadow-lg w-96"
      />
<br></br>
      
<p className="mt-4 text-base text-gray-700 text-center">
  We’re excited to announce a new version of SmartViewMD. To provide context, we’ve included a carousel of short videos: the{" "}
  <LinkButton onClick={() => setCurrentIndex(0)}>first</LinkButton>{" "}
  offers a quick demo of the camera feature, the{" "}
  <LinkButton onClick={() => setCurrentIndex(1)}>second</LinkButton>{" "}
  is an introduction from our recent presentation at the CHI Community Health Conference & Expo in Chicago, the{" "}
  <LinkButton onClick={() => setCurrentIndex(2)}>third</LinkButton>{" "}
  explains our problem statement and initiative, the{" "}
  <LinkButton onClick={() => setCurrentIndex(3)}>fourth</LinkButton>{" "}
  shows how the tool works, the{" "}
  <LinkButton onClick={() => setCurrentIndex(4)}>fifth</LinkButton>{" "}
  shares key learnings, and the{" "}
  <LinkButton onClick={() => setCurrentIndex(5)}>final</LinkButton>{" "}
  video provides a summary.
</p>



      <br />
      <br />
      <br />
    </div>
  );
};

export default VideoPlayer;
